import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import {
  XCCA,
  SYSTEM_CONFIGURATION_ROUTE,
  XCCA_DASHBOARD
} from '../../constants';
import XccaList from './containers/XccaList/XccaList';

interface Props {}

const Xcca: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${XCCA}${XCCA_DASHBOARD}`}>
        <XccaList />
      </Route>
    </Fragment>
  );
};

export default Xcca;
